module.exports = __webpack_public_path__ + "static/media/arman.bcadfd07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/arman.jpg
// module id = 736
// module chunks = 0